import Cookies from 'js-cookie';
import type { CookieClient } from '@/scopes/common/domain/types';

const cookieClient: CookieClient = {
  get: (name) => Cookies.get(name),

  set: (name, value, opts) =>
    Cookies.set(name, value, {
      path: opts?.path ?? '/',
      expires: opts?.expirationDays,
    }),

  del: (name) => {
    Cookies.remove(name, { path: '/' });
  },
};

export default cookieClient;
